const Footer = () => {
  return <footer className="footer">© {new Date().getFullYear()} Yusuf Haji</footer>;
};

export default Footer;
